/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddBiasTestsRequest,
  AddGroupsRequest,
  ExperimentCreate,
  ExperimentDetailResponse,
  ExperimentResponse,
  HTTPValidationError,
  RemoveGroupsRequest,
} from '../models/index';
import {
    AddBiasTestsRequestFromJSON,
    AddBiasTestsRequestToJSON,
    AddGroupsRequestFromJSON,
    AddGroupsRequestToJSON,
    ExperimentCreateFromJSON,
    ExperimentCreateToJSON,
    ExperimentDetailResponseFromJSON,
    ExperimentDetailResponseToJSON,
    ExperimentResponseFromJSON,
    ExperimentResponseToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    RemoveGroupsRequestFromJSON,
    RemoveGroupsRequestToJSON,
} from '../models/index';

export interface AddBiasTestsToExperimentApiExperimentsExperimentIdBiasTestsPostRequest {
    experimentId: number;
    addBiasTestsRequest: AddBiasTestsRequest;
    xApiKey?: string | null;
}

export interface AddGroupsToExperimentApiExperimentsExperimentIdGroupsPostRequest {
    experimentId: number;
    addGroupsRequest: AddGroupsRequest;
    xApiKey?: string | null;
}

export interface CreateExperimentApiExperimentsPostRequest {
    experimentCreate: ExperimentCreate;
    xApiKey?: string | null;
}

export interface DeleteExperimentApiExperimentsExperimentIdDeleteRequest {
    experimentId: number;
    xApiKey?: string | null;
}

export interface GetBiasTestApiExperimentsBiasTestsKeyGetRequest {
    key: string;
    xApiKey?: string | null;
}

export interface GetExperimentApiExperimentsExperimentIdGetRequest {
    experimentId: number;
    xApiKey?: string | null;
}

export interface ListBiasTestsApiExperimentsBiasTestsGetRequest {
    xApiKey?: string | null;
}

export interface ListExperimentsApiExperimentsGetRequest {
    xApiKey?: string | null;
}

export interface RemoveGroupsFromExperimentApiExperimentsExperimentIdGroupsDeleteRequest {
    experimentId: number;
    removeGroupsRequest: RemoveGroupsRequest;
    xApiKey?: string | null;
}

/**
 * 
 */
export class ExperimentsApi extends runtime.BaseAPI {

    /**
     * Add bias tests to an existing experiment by creating groups from them.
     * Add Bias Tests To Experiment
     */
    async addBiasTestsToExperimentApiExperimentsExperimentIdBiasTestsPostRaw(requestParameters: AddBiasTestsToExperimentApiExperimentsExperimentIdBiasTestsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExperimentResponse>> {
        if (requestParameters['experimentId'] == null) {
            throw new runtime.RequiredError(
                'experimentId',
                'Required parameter "experimentId" was null or undefined when calling addBiasTestsToExperimentApiExperimentsExperimentIdBiasTestsPost().'
            );
        }

        if (requestParameters['addBiasTestsRequest'] == null) {
            throw new runtime.RequiredError(
                'addBiasTestsRequest',
                'Required parameter "addBiasTestsRequest" was null or undefined when calling addBiasTestsToExperimentApiExperimentsExperimentIdBiasTestsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/experiments/{experiment_id}/bias-tests`;
        urlPath = urlPath.replace(`{${"experiment_id"}}`, encodeURIComponent(String(requestParameters['experimentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddBiasTestsRequestToJSON(requestParameters['addBiasTestsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExperimentResponseFromJSON(jsonValue));
    }

    /**
     * Add bias tests to an existing experiment by creating groups from them.
     * Add Bias Tests To Experiment
     */
    async addBiasTestsToExperimentApiExperimentsExperimentIdBiasTestsPost(requestParameters: AddBiasTestsToExperimentApiExperimentsExperimentIdBiasTestsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExperimentResponse> {
        const response = await this.addBiasTestsToExperimentApiExperimentsExperimentIdBiasTestsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add groups to an experiment.
     * Add Groups To Experiment
     */
    async addGroupsToExperimentApiExperimentsExperimentIdGroupsPostRaw(requestParameters: AddGroupsToExperimentApiExperimentsExperimentIdGroupsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExperimentResponse>> {
        if (requestParameters['experimentId'] == null) {
            throw new runtime.RequiredError(
                'experimentId',
                'Required parameter "experimentId" was null or undefined when calling addGroupsToExperimentApiExperimentsExperimentIdGroupsPost().'
            );
        }

        if (requestParameters['addGroupsRequest'] == null) {
            throw new runtime.RequiredError(
                'addGroupsRequest',
                'Required parameter "addGroupsRequest" was null or undefined when calling addGroupsToExperimentApiExperimentsExperimentIdGroupsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/experiments/{experiment_id}/groups`;
        urlPath = urlPath.replace(`{${"experiment_id"}}`, encodeURIComponent(String(requestParameters['experimentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddGroupsRequestToJSON(requestParameters['addGroupsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExperimentResponseFromJSON(jsonValue));
    }

    /**
     * Add groups to an experiment.
     * Add Groups To Experiment
     */
    async addGroupsToExperimentApiExperimentsExperimentIdGroupsPost(requestParameters: AddGroupsToExperimentApiExperimentsExperimentIdGroupsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExperimentResponse> {
        const response = await this.addGroupsToExperimentApiExperimentsExperimentIdGroupsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new experiment with optional bias tests.
     * Create Experiment
     */
    async createExperimentApiExperimentsPostRaw(requestParameters: CreateExperimentApiExperimentsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExperimentResponse>> {
        if (requestParameters['experimentCreate'] == null) {
            throw new runtime.RequiredError(
                'experimentCreate',
                'Required parameter "experimentCreate" was null or undefined when calling createExperimentApiExperimentsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/experiments`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ExperimentCreateToJSON(requestParameters['experimentCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExperimentResponseFromJSON(jsonValue));
    }

    /**
     * Create a new experiment with optional bias tests.
     * Create Experiment
     */
    async createExperimentApiExperimentsPost(requestParameters: CreateExperimentApiExperimentsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExperimentResponse> {
        const response = await this.createExperimentApiExperimentsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete an experiment.
     * Delete Experiment
     */
    async deleteExperimentApiExperimentsExperimentIdDeleteRaw(requestParameters: DeleteExperimentApiExperimentsExperimentIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExperimentResponse>> {
        if (requestParameters['experimentId'] == null) {
            throw new runtime.RequiredError(
                'experimentId',
                'Required parameter "experimentId" was null or undefined when calling deleteExperimentApiExperimentsExperimentIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/experiments/{experiment_id}`;
        urlPath = urlPath.replace(`{${"experiment_id"}}`, encodeURIComponent(String(requestParameters['experimentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExperimentResponseFromJSON(jsonValue));
    }

    /**
     * Delete an experiment.
     * Delete Experiment
     */
    async deleteExperimentApiExperimentsExperimentIdDelete(requestParameters: DeleteExperimentApiExperimentsExperimentIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExperimentResponse> {
        const response = await this.deleteExperimentApiExperimentsExperimentIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get schema for a specific bias test.
     * Get Bias Test
     */
    async getBiasTestApiExperimentsBiasTestsKeyGetRaw(requestParameters: GetBiasTestApiExperimentsBiasTestsKeyGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling getBiasTestApiExperimentsBiasTestsKeyGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/experiments/bias-tests/{key}`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get schema for a specific bias test.
     * Get Bias Test
     */
    async getBiasTestApiExperimentsBiasTestsKeyGet(requestParameters: GetBiasTestApiExperimentsBiasTestsKeyGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getBiasTestApiExperimentsBiasTestsKeyGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get experiment with full group details.
     * Get Experiment
     */
    async getExperimentApiExperimentsExperimentIdGetRaw(requestParameters: GetExperimentApiExperimentsExperimentIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExperimentDetailResponse>> {
        if (requestParameters['experimentId'] == null) {
            throw new runtime.RequiredError(
                'experimentId',
                'Required parameter "experimentId" was null or undefined when calling getExperimentApiExperimentsExperimentIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/experiments/{experiment_id}`;
        urlPath = urlPath.replace(`{${"experiment_id"}}`, encodeURIComponent(String(requestParameters['experimentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExperimentDetailResponseFromJSON(jsonValue));
    }

    /**
     * Get experiment with full group details.
     * Get Experiment
     */
    async getExperimentApiExperimentsExperimentIdGet(requestParameters: GetExperimentApiExperimentsExperimentIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExperimentDetailResponse> {
        const response = await this.getExperimentApiExperimentsExperimentIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all bias tests with their JSON schemas for dynamic UI form rendering.
     * List Bias Tests
     */
    async listBiasTestsApiExperimentsBiasTestsGetRaw(requestParameters: ListBiasTestsApiExperimentsBiasTestsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<{ [key: string]: any; }>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/experiments/bias-tests`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get all bias tests with their JSON schemas for dynamic UI form rendering.
     * List Bias Tests
     */
    async listBiasTestsApiExperimentsBiasTestsGet(requestParameters: ListBiasTestsApiExperimentsBiasTestsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<{ [key: string]: any; }>> {
        const response = await this.listBiasTestsApiExperimentsBiasTestsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all experiments, ordered by creation time (newest first).
     * List Experiments
     */
    async listExperimentsApiExperimentsGetRaw(requestParameters: ListExperimentsApiExperimentsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ExperimentResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/experiments`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ExperimentResponseFromJSON));
    }

    /**
     * Get all experiments, ordered by creation time (newest first).
     * List Experiments
     */
    async listExperimentsApiExperimentsGet(requestParameters: ListExperimentsApiExperimentsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ExperimentResponse>> {
        const response = await this.listExperimentsApiExperimentsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove groups from an experiment (groups become standalone).
     * Remove Groups From Experiment
     */
    async removeGroupsFromExperimentApiExperimentsExperimentIdGroupsDeleteRaw(requestParameters: RemoveGroupsFromExperimentApiExperimentsExperimentIdGroupsDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExperimentResponse>> {
        if (requestParameters['experimentId'] == null) {
            throw new runtime.RequiredError(
                'experimentId',
                'Required parameter "experimentId" was null or undefined when calling removeGroupsFromExperimentApiExperimentsExperimentIdGroupsDelete().'
            );
        }

        if (requestParameters['removeGroupsRequest'] == null) {
            throw new runtime.RequiredError(
                'removeGroupsRequest',
                'Required parameter "removeGroupsRequest" was null or undefined when calling removeGroupsFromExperimentApiExperimentsExperimentIdGroupsDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/experiments/{experiment_id}/groups`;
        urlPath = urlPath.replace(`{${"experiment_id"}}`, encodeURIComponent(String(requestParameters['experimentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: RemoveGroupsRequestToJSON(requestParameters['removeGroupsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExperimentResponseFromJSON(jsonValue));
    }

    /**
     * Remove groups from an experiment (groups become standalone).
     * Remove Groups From Experiment
     */
    async removeGroupsFromExperimentApiExperimentsExperimentIdGroupsDelete(requestParameters: RemoveGroupsFromExperimentApiExperimentsExperimentIdGroupsDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExperimentResponse> {
        const response = await this.removeGroupsFromExperimentApiExperimentsExperimentIdGroupsDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
